import React from 'react';
import { Chip } from '@mui/material';
import useDesignTokens from './useDesignTokens';

// Reads statusColors() from the theme — never accepts a hex colour prop.
// `status` is the semantic key (pending/accepted/paid/rejected/draft/issued/
// overdue/void/processing); `label` is the already-translated display text.
const StatusChip = ({ status, label, sx }) => {
  const { statusColors } = useDesignTokens();
  const tone = statusColors[status];

  return (
    <Chip
      label={label}
      sx={{
        bgcolor: tone ? tone.bg : 'action.selected',
        color: tone ? tone.ink : 'text.secondary',
        ...sx,
      }}
    />
  );
};

export default StatusChip;
